import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { PixMenu } from '../../models/pix-menu.enum';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PixMyQrCodeComponent } from '../../my-qr-code/my-qr-code.component';
import { PixHelpComponent } from '../../help/help.component';
import { Router } from '@angular/router';
import { PixKeysService } from '../../keys/keys.service';
import { PixKey } from '../../models/key.model';
import { Util } from '../../../../utils/util';
import { PixKeyType } from '../../models/key-type.enum';
import { ModalConfirmComponent } from '../../../../shared/modal-confirm/modal-confirm.component';

@Component({
	selector: 'app-pix-home-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixHomeMenuComponent implements OnInit {
	@Input() selectedPixMenu: PixMenu;
	public mainKey: PixKey;

	constructor(
		public dialog: MatDialog,
		private pixKeysService: PixKeysService,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.getMainKey();
	}

	getMainKey() {
		this.pixKeysService.getMain().subscribe(data => {
			if (data && data.Existe && data.Sucesso) {
				this.mainKey = Util.keysToCamel(data.Retorno) as PixKey;
			}
		});
	}

	selectMyQrCode() {
		if (this.mainKey) {
			this.openModalQrCode();
		} else {
			this.router.navigate(['pix/chaves/criar']);
		}
	}

	selectHelp() {
		this.openModalHelp();
	}

	openModalQrCode() {
		const dialogRef = this.dialog.open(PixMyQrCodeComponent, {
			width: '440px',
			data: this.mainKey
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
			}
		});
	}

	openModalHelp() {
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

	openModalAutomaticDebit() {
		this.dialog.open(ModalConfirmComponent, {
			width: '350px',
			data: {
				title: "Disponível apenas no aplicativo Omni Banco",
				text: "Acesse seu app Omni Banco para cadastrar, autorizar ou acompanhar seus pagamentos automáticos Pix.",
        hideBackButton: true,
        confirmButton: 'Entendi',
			}
		});
	}

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}

	public get keyType(): typeof PixKeyType {
		return PixKeyType;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/home/menu/menu.component.ts